//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sectionIndex from '~/components/section/index/section'
import { lowerCase } from '~/utils/utils'

export default {
  name: 'JobsSlider',
  components: {
    sectionIndex
  },
  props: {
    slider: {
      type: Object,
      default: () => {}
    },
    locations: {
      type: Array,
      default: () => []
    },
    container: {
      type: Boolean,
      default: false
    }
  }
}
